<button mat-button (click)="openDialog()" class="btn-modal">
  {{text}}
</button>
